import React, { useReducer } from 'react'
import AccessHoursReducer from './AccessHoursReducer';
import AccessHoursContext from './AccessHoursContext';
import { getAccessHoursService } from '../../services/accessHours';

const AccessHoursState = ({ children }) => {

    const initialState = {
        accessHours: [],
        isFetching: true,
        wasFetched: false,
        error: false,
        message: ''
    };

    const [state, dispatch] = useReducer(AccessHoursReducer, initialState);

    const getAccessHours = async () => {
        try {
            if (state.wasFetched === false) {
                const accessHours = await getAccessHoursService();
                if (accessHours.ok) {
                    dispatch({
                        type: 'GET_ACCESS_HOURS',
                        payload: accessHours.data.response
                    });
                }
            }
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <AccessHoursContext.Provider
            value={{
                accessHoursState: state,
                getAccessHours
            }}
        >
            {children}
        </AccessHoursContext.Provider>
    );
}

export default AccessHoursState